import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a010832"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "nfo" }
const _hoisted_3 = { class: "nfo-box" }
const _hoisted_4 = { class: "nfo-title" }
const _hoisted_5 = { class: "nfo-ok" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('me.sznc'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.back()))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_field, {
          modelValue: $setup.name,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => (($setup.name) = $event)),
            $setup.checkValue
          ],
          clearable: "",
          placeholder: $setup.t('me.qsrnc')
        }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('me.nccccc')), 1 /* TEXT */),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('me.textnc3')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.ok()))
        }, _toDisplayString(_ctx.$t('im.wanc')), 1 /* TEXT */)
      ])
    ])
  ]))
}